import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/playlist-icon.png'


const _hoisted_1 = { class: "resource-playlist" }
const _hoisted_2 = { class: "playlist-header" }
const _hoisted_3 = { class: "container maxWidth-sm" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-sm-7" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "playlist-icon",
  alt: "playlist icon"
}, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1)
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "col-sm-5" }
const _hoisted_12 = { class: "resource-playlist-resources text-center" }

import { debug as d } from "debug";
import { computed, onMounted } from "vue";
import {
  CmsDocument,
  CmsResourcePlaylist,
  CmsResourceRelationship,
} from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import CmsImg from "../../components/cms/cms-img.vue";

import ResourceTile from "../../components/cms/resource-tile.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'resource-playlist',
  props: {
    doc: {}
  },
  setup(__props: any) {

const debug = d("cs.CmsResourcePlaylist");

const props = __props;
const doc = computed(() => props.doc as CmsResourcePlaylist);

onMounted(() => {
  debug("Mounting");
});

const title = computed(() => cms.asText(doc.value.data.title));
const hasOverview = computed(() => !!doc.value.data.overview_button_link?.uid);
const resources = computed(() => doc.value.data.items.map((i) => i.link) ?? []);
const overviewTitle = computed(() =>
  !hasOverview.value ? "" : cms.asText(doc.value.data.overview_button_title) || "Overview",
);
const overviewUrl = computed(() => cms.linkResolver(doc.value.data.overview_button_link));
const descriptionHtml = computed(() => cms.asHtml(doc.value.data.description));
const titleImage = computed(() => doc.value.data.title_image);
const items = computed(() => {
  return doc.value.data.items.map((i) => {
    const { data } = i.link as CmsResourceRelationship;
    return {
      href: cms.linkResolver(i.link),
      title: cms.asText(data?.tile_title).trim() || cms.asText(data?.title),
      src: data?.tile_image_animation?.url || data?.title_image?.tile || data?.title_image,
    };
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (title.value)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_7, _toDisplayString(title.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", { innerHTML: descriptionHtml.value }, null, 8, _hoisted_8),
            _hoisted_9,
            _createElementVNode("p", null, [
              (hasOverview.value)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "btn btn-primary",
                    href: overviewUrl.value
                  }, _toDisplayString(overviewTitle.value), 9, _hoisted_10))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(CmsImg, {
              style: {"width":"100%"},
              src: titleImage.value
            }, null, 8, ["src"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
        return (_openBlock(), _createBlock(ResourceTile, {
          key: item.title,
          src: item.src,
          title: item.title,
          href: item.href
        }, null, 8, ["src", "title", "href"]))
      }), 128))
    ])
  ]))
}
}

})